import axios from 'axios'

const config = {
  headers: {
    'Content-Type': 'application/json'
  }
}

const getters = {
  HIST_LIST: state => state.hist,
}
const mutations = {
  SET_HIST_LIST: (state, payload) => {
    state.hist = payload.data
  },
}
const actions = {
  GET_HIST_LIST: async (context, payload) => {
    const { data } = await axios.post('/wallet/history/list', payload, config)
    if (data !== undefined) {
      context.commit('SET_HIST_LIST', data)
    }
    return data
  }
}

export default {
  state: () => ({
    hist: null
  }),
  mutations,
  actions,
  getters
}
